'use strict'

exports.geojson_substations = require('./network/geojson_substations.json')
exports.geojson_lines = require('./network/geojson_lines.json')
exports.geojson_400kV_Substations = require('./network/geojson_400kV_Substations.json')
exports.geojson_220kV_Substations = require('./network/geojson_220kV_Substations.json')
exports.geojson_20kV_Substations = require('./network/geojson_20kV_Substations.json')
exports.geojson_110kV_Lines = require('./network/geojson_110kV_Lines.json')
exports.geojson_10kV_Substations = require('./network/geojson_10kV_Substations.json')
exports.geojson_20kV_Lines = require('./network/geojson_20kV_Lines.json')
exports.geojson_10kV_Lines = require('./network/geojson_10kV_Lines.json')

exports.bulgariaSubstationsHV = require('./network/bulgariaSubstationsHV.json')
exports.bulgariaLinesHV = require('./network/bulgariaLinesHV.json')
exports.bulgaria_220kV_Substations = require('./network/bulgaria_220kV_Substations.json')
exports.bulgaria_220kV_Lines = require('./network/bulgaria_220kV_Lines.json')
exports.bulgaria_400kV_Substations = require('./network/bulgaria_400kV_Substations.json')
exports.bulgaria_400kV_Lines = require('./network/bulgaria_400kV_Lines.json')
exports.bulgaria_20kV_Substations = require('./network/bulgaria_20kV_Substations.json')
exports.bulgaria_20kV_Lines = require('./network/bulgaria_20kV_Lines.json')
exports.bulgaria_10kV_Substations = require('./network/bulgaria_10kV_Substations.json')
exports.bulgaria_10kV_Lines = require('./network/bulgaria_10kV_Lines.json')

exports.slovenia_220kV_Substations = require('./network/slovenia_220kV_Substations.json')
exports.slovenia_220kV_Lines = require('./network/slovenia_220kV_Lines.json')
exports.slovenia_400kV_Substations = require('./network/slovenia_400kV_Substations.json')
exports.slovenia_400kV_Lines = require('./network/slovenia_400kV_Lines.json')
exports.slovenia_20kV_Substations = require('./network/slovenia_20kV_Substations.json')
exports.slovenia_20kV_Lines = require('./network/slovenia_20kV_Lines.json')
exports.slovenia_10kV_Substations = require('./network/slovenia_10kV_Substations.json')
exports.slovenia_10kV_Lines = require('./network/slovenia_10kV_Lines.json')

exports.switzerland_10kV_Substations = require('./network/switzerland_10kV_Substations.json')
exports.switzerland_10kV_Lines = require('./network/switzerland_10kV_Lines.json')
exports.switzerland_20kV_Substations = require('./network/switzerland_20kV_Substations.json')
exports.switzerland_20kV_Lines = require('./network/switzerland_20kV_Lines.json')
exports.switzerland_220kV_Substations = require('./network/switzerland_220kV_Substations.json')
exports.switzerland_220kV_Lines = require('./network/switzerland_220kV_Lines.json')
exports.switzerland_400kV_Substations = require('./network/switzerland_400kV_Substations.json')
exports.switzerland_400kV_Lines = require('./network/switzerland_400kV_Lines.json')

exports.turkey_400kV_Substations = require('./network/turkey_400kV_Substations.json')
exports.turkey_400kV_Lines = require('./network/turkey_400kV_Lines.json')
exports.turkey_154kV_Substations = require('./network/turkey_154kV_Substations.json')
exports.turkey_154kV_Lines = require('./network/turkey_154kV_Lines.json')
exports.turkey_20kV_Substations = require('./network/turkey_20kV_Substations.json')
exports.turkey_20kV_Lines = require('./network/turkey_20kV_Lines.json')
exports.turkey_10kV_Substations = require('./network/turkey_10kV_Substations.json')
exports.turkey_10kV_Lines = require('./network/turkey_10kV_Lines.json')

exports.geojsonOffers = require('./geojsonOffers.json')
exports.bulgariaOffers = require('./bulgaria/bulgariaOffers.json')
exports.turkeyOffers = require('./turkey/turkeyOffers.json')

exports.brusselsCustomers = require('./brusselsCustomers.json')
exports.brusselsNonCustomers = require('./brusselsNonCustomers.json')
exports.myLocation = require('./myLocation.json')
exports.customers = require('./customers.json')
exports.wind = require('./wind.json')
exports.solar = require('./solar.json')

exports.load= require('./load.json')
exports.ev= require('./ev.json')
exports.generation= require('./generation.json')

exports.loadRomania= require('./romania/load_assets.json')
exports.evRomania= require('./romania/ev_assets.json')
exports.generationRomania= require('./romania/generation_assets.json')

exports.loadBulgaria= require('./bulgaria/bulgaria_load_assets.json')
exports.evBulgaria= require('./bulgaria/bulgaria_ev_assets.json')
exports.generationBulgaria= require('./bulgaria/bulgaria_generation_assets.json')

exports.loadSlovenia= require('./slovenia/slovenia_load_assets.json')
exports.evSlovenia= require('./slovenia/slovenia_ev_assets.json')
exports.generationSlovenia= require('./slovenia/slovenia_generation_assets.json')

exports.loadSwitzerland= require('./switzerland/switzerland_load_assets.json')
exports.evSwitzerland= require('./switzerland/switzerland_ev_assets.json')
exports.generationSwitzerland= require('./switzerland/switzerland_generation_assets.json')

exports.loadTurkey= require('./turkey/asset_load_turkey.json')
exports.evTurkey= require('./turkey/asset_ev_turkey.json')
exports.generationTurkey= require('./turkey/asset_generation_turkey.json')

/* 
exports.load= require('./turkey/asset_load_turkey.json')
exports.ev= require('./turkey/asset_ev_turkey.json')
exports.generation= require('./turkey/asset_generation_turkey.json') 
*/

//exports.BEDSO01= require('./belgium/Fluvius.json')
//exports.BEDSO02= require('./belgium/Sibelga.json')
//exports.BEDSO03= require('./belgium/Ores.json')
//exports.BEDSO04= require('./belgium/Resa.json')

//exports.evn_area= require('.//bulgaria/dso_evn_area_2020.json')
//exports.cez_area= require('./bulgaria/dso_cez_area_2020.json')
//exports.nord_area= require('./bulgaria/dso_nord_area_2020.json')
exports.BGDSO01= require('./bulgaria/DSO_CEZ_Area.json')
exports.BGDSO02= require('./bulgaria/DSO_EVN_Area.json')
exports.BGDSO03= require('./bulgaria/DSO_Nord_Area.json')

exports.CHDSO01= require('./switzerland/Lake_Geneva.json')

exports.NLDSO01= require('./netherlands/Liander.json')
exports.NLDSO02= require('./netherlands/Enexis.json')
exports.NLDSO03= require('./netherlands/Stedin.json')
exports.NLDSO04= require('./netherlands/Enduris.json')

//exports.PTDSO01= require('./portugal/EDA.json')
//exports.PTDSO02= require('./portugal/EEM.json')
//exports.PTDSO03= require('./portugal/EDP.json')

/* exports.eon_moldova= require('./EON_Moldova.json')
exports.electrica_muntenia_nord= require('./Electrica_Muntenia_Nord.json')
exports.electrica_transilvania_nord= require('./Electrica_Transilvania_Nord.json')
exports.electrica_transilvania_sud= require('./Electrica_Transilvania_Sud.json')
exports.cez_oltenia= require('./CEZ_Oltenia.json')
exports.enel_banat= require('./Enel_Banat.json')
exports.enel_dobrogea= require('./Enel_Dobrogea.json')
exports.enel_muntenia_sud= require('./Enel_Muntenia_Sud.json')
exports.Enel_Banat_2020= require('./Enel_Banat_2020.json') */

exports.RODSO01= require('./romania/EON_Moldova.json')
exports.RODSO02= require('./romania/Electrica_Muntenia_Nord.json')
exports.RODSO03= require('./romania/Electrica_Transilvania_Nord.json')
exports.RODSO04= require('./romania/Electrica_Transilvania_Sud.json')
exports.RODSO05= require('./romania/CEZ_Oltenia.json')
exports.RODSO06= require('./romania/Enel_Banat.json')
exports.RODSO07= require('./romania/Enel_Dobrogea.json')
exports.RODSO08= require('./romania/Enel_Muntenia_Sud.json')

/* exports.ESDSO01= require('./spain/Endesa.json')
exports.ESDSO02= require('./spain/Iberdrola.json')
exports.ESDSO03= require('./spain/Fenosa.json')
exports.ESDSO04= require('./spain/Energia.json')
exports.ESDSO05= require('./spain/EON_Espana.json') */

exports.SIDSO01= require('./slovenia/Gorenjska.json')
exports.SIDSO02= require('./slovenia/Ljubljana.json')
exports.SIDSO03= require('./slovenia/Primorska.json')
exports.SIDSO04= require('./slovenia/Celje.json')
exports.SIDSO05= require('./slovenia/Maribor.json')

exports.TRDSO01= require('./turkey/Dicle.json')
exports.TRDSO02= require('./turkey/Vangolu.json')
exports.TRDSO03= require('./turkey/Aras.json')
exports.TRDSO04= require('./turkey/Coruh.json')
exports.TRDSO05= require('./turkey/Firat.json')
exports.TRDSO06= require('./turkey/Camlibel.json')
exports.TRDSO07= require('./turkey/Toroslar.json')
exports.TRDSO08= require('./turkey/Meram.json')
exports.TRDSO09= require('./turkey/Baskent.json')
exports.TRDSO10= require('./turkey/Akdeniz.json')
exports.TRDSO11= require('./turkey/Gediz.json')
exports.TRDSO12= require('./turkey/Uludag.json')
exports.TRDSO13= require('./turkey/Trakya.json')
exports.TRDSO14= require('./turkey/Istanbul.json')
exports.TRDSO15= require('./turkey/Sakarya.json')
exports.TRDSO16= require('./turkey/Osmangazi.json')
exports.TRDSO17= require('./turkey/Bogazici.json')
exports.TRDSO18= require('./turkey/Kayseri.json')
exports.TRDSO19= require('./turkey/Menderes.json')
exports.TRDSO20= require('./turkey/Goksu.json')
exports.TRDSO21= require('./turkey/Yesilirmak.json')

/* 
exports.test2020= require('./test2020.json')
exports.test2021= require('./test2021.json')
exports.test2022= require('./test2022.json')
exports.test2023= require('./test2023.json')
exports.test2024= require('./test2024.json')
exports.test2025= require('./test2025.json')
exports.test2023= require('./2023.json')

exports.y_2020= require('./bulgaria/dso_nord_area_2020.json')
exports.y_2021= require('./bulgaria/dso_nord_area_2021.json')
exports.y_2022= require('./bulgaria/dso_nord_area_2022.json')
exports.y_2023= require('./bulgaria/dso_nord_area_2023.json')
exports.y_2024= require('./bulgaria/dso_nord_area_2024.json')
exports.y_2025= require('./bulgaria/dso_nord_area_2025.json')

exports.gene2020= require('./generation2020.json')
exports.gene2021= require('./generation2021.json')
exports.gene2022= require('./generation2022.json')
exports.gene2023= require('./generation2023.json')
exports.gene2024= require('./generation2024.json')
exports.gene2025= require('./generation2025.json') 
*/